<template>

  <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

    <!--Add Edit - Invoice -->

    <v-toolbar tabs fixed light color="white">
      <v-btn icon @click.native="closeDialog" light>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="selectedItem.id === 0">Add Invoice</v-toolbar-title>
      <v-toolbar-title v-else>Edit Invoice - {{ selectedItem.invoice_number }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tabs slot="extension"
              v-model="activeTabIndex"
              color="secondary"
              dark
              slider-color="primary"
              class="fixSides"
              show-arrows

      >
        <v-tab>INVOICE</v-tab>
        <v-tab :disabled="tabsDisabled">INVOICE POSITIONS</v-tab>
        <v-tab :disabled="pickingTabDisabled">PICKINGS</v-tab>
        <v-tab :disabled="sendInvoiceDisabled">SEND INVOICE</v-tab>
      </v-tabs>

      <v-toolbar-items>
        <v-menu
          transition="slide-y-transition"
          :nudge-bottom="20"
          :nudge-right="0"
          :nudge-left="0">
          <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                 slot="activator"
                 icon>

            <v-icon dark>more_vert</v-icon>
          </v-btn>
          <v-list v-show="$vuetify.breakpoint.lgAndUp">
            <v-list-tile @click.native="saveAll()">
              <v-list-tile-title>
                <v-icon color="secondary">save</v-icon>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click.native="deleteAll()">
              <v-list-tile-title>
                <v-icon color="red">delete</v-icon>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>

    </v-toolbar>

    <v-tabs-items class="fromTop" v-model="activeTabIndex"
                  :touchless="touchless"
    >
      <v-tab-item>

        <v-layout wrap>
          <v-container grid-list-md>
            <v-flex xs12 xl6 offset-xl3>
              <v-hover>
                <v-card slot-scope="{ hover }"
                        :class="`elevation-${hover ? 4 : 1}`">
                  <v-card-title class="headline">{{ cardTitle }} Invoice
                    <v-spacer></v-spacer>
                    <v-autocomplete v-show="!getInitialLoading"
                                    v-if="selectedItem.id > 0"
                                    class="statusSelecter"
                                    :items="statuses"
                                    item-text="name"
                                    item-value="id"
                                    label="Invoice Status"
                                    v-model="selectedItem.invoices_status_id"
                    ></v-autocomplete>
                  </v-card-title>

                  <v-card-title>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Customer</v-subheader>
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      :items="getCustomers"
                                      label="Customer"
                                      :search-input.sync="searchCustomer"
                                      v-model="selectedItem.customers_id"
                                      :loading="loading"
                                      hide-details
                                      item-value="id"
                                      item-text="name"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      :items="getCustomerBranchOffices"
                                      label="Branch Office"
                                      :search-input.sync="searchCustomerBranchOffice"
                                      v-model="selectedItem.customers_branch_offices_id"
                                      :loading="loading"
                                      hide-details
                                      item-value="id"
                                      item-text="name"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete
                        clearable v-show="!getInitialLoading"
                        :items="getCustomerBranchOfficesContacts"
                        label="Contact Person"
                        :search-input.sync="searchCustomerBranchOfficeContact"
                        v-model="selectedItem.customers_branch_offices_contacts_id"
                        :loading="loading"
                        :filter="customContactFilter"
                        hide-details
                        item-value="id"
                        item-text="name">

                        <template slot="selection" slot-scope="data">
                          {{ data.item.title }} {{ data.item.firstname }} {{
                            data.item.lastname
                          }}
                        </template>

                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title
                            >
                              {{ data.item.title }} {{ data.item.firstname }} {{
                                data.item.lastname
                              }}
                            </v-list-tile-title>
                            <!-- <v-list-tile-sub-title>
                                 {{ data.item.email }}
                             </v-list-tile-sub-title>-->
                          </v-list-tile-content>
                        </template>

                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Invoice options</v-subheader>
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <DatetimePicker v-show="!getInitialLoading"
                                      locale="de-DE"
                                      landscape
                                      mysql
                                      :width="width = 500"
                                      label="Invoice Date"
                                      v-model="selectedItem.invoice_date"
                                      format="DD.MM.YYYY"
                                      :dateOnly="true"
                      >
                      </DatetimePicker>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      v-model="selectedItem.currencies_id"
                                      :items="getCurrencies"
                                      label="Currency"
                                      item-value="id"
                                      item-text="name"
                      ></v-autocomplete>
                    </v-flex>

                    <!--                                       <v-flex xs12 md6 pl-4 pa-2>
                                                               <v-layout>
                                                                   <v-spacer></v-spacer>
                                                                   &lt;!&ndash;                                                <DocumentTokenChip
                                                                                                                           v-show="selectedItem.documents_id !== 0 && selectedItem.documents_id !== null && !getInitialLoading"
                                                                                                                           :documentsId="selectedItem.documents_id"
                                                                                                                           :documentFilename="selectedItem.suppliers_orders_confirmation_number + '.pdf'"
                                                                                                                   >
                                                                                                                   </DocumentTokenChip>&ndash;&gt;
                                                               </v-layout>
                                                           </v-flex>
                   -->
                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <DatetimePicker v-show="!getInitialLoading"
                                      locale="de-DE"
                                      landscape
                                      mysql
                                      :width="width = 500"
                                      label="Due Date (optional)"
                                      v-model="selectedItem.due_date"
                                      format="DD.MM.YYYY"
                                      :dateOnly="true"
                      >
                      </DatetimePicker>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete
                        v-show="!getInitialLoading"
                        :items="invoiceTypes"
                        item-text="name"
                        item-value="id"
                        label="Invoice Type"
                        v-model="selectedItem.invoices_types_id"
                        required
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Terms</v-subheader>
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete
                        v-show="!getInitialLoading"
                        :items="termsOfPayment"
                        item-text="name"
                        item-value="id"
                        label="Term of Payment"
                        v-model="selectedItem.terms_of_payments_id"
                        required
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete
                        v-show="!getInitialLoading"
                        :items="termsOfDelivery"
                        item-text="name"
                        item-value="id"
                        label="Term of Delivery"
                        v-model="selectedItem.terms_of_deliveries_id"
                        required
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Term Remark</v-subheader>
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 md12 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-textarea
                        v-show="!getInitialLoading"
                        auto-grow
                        rows="4"
                        label="Remark"
                        v-model="selectedItem.term_remark"
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Select Ready for Invoice Purchase Order Positions</v-subheader>
                      <v-divider></v-divider>
                    </v-flex>

                    <template>
                      <v-flex xs12 pr-3 pl-3>
                        <v-card>
                          <v-tabs
                            dark
                            vertical
                            v-model="selectedInvoiceTabFreeVModel">
                            <v-tabs-slider color="yellow"></v-tabs-slider>
                            <v-tab>
                              Normal
                            </v-tab>
                            <v-tab>
                              Free
                            </v-tab>

                            <v-tab-item>
                              <v-card flat>
                                <v-flex xs12 md6 pl-4 pr-4 pa-2>
                                  <FakeItem v-show="getInitialLoading">
                                  </FakeItem>
                                  <v-text-field v-show="!getInitialLoading"
                                                v-model="search"
                                                append-icon="search"
                                                label="Search"
                                                single-line
                                                hide-details
                                                clearable
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md12 pl-4 pa-2>

                                  <FakeTable v-show="getInitialLoading">
                                  </FakeTable>
                                  <v-data-table v-show="!getInitialLoading"
                                                v-model="selectedPurchasePositions"
                                                :headers="headers"
                                                :items="getReadyForInvoicePositions"
                                                :pagination.sync="pagination"
                                                :total-items=total
                                                class="elevation-0"
                                                :loading="loading"
                                                :rows-per-page-items="rowsPageItems"
                                                select-all
                                  >

                                    <template slot="headerCell" slot-scope="props">
                                      <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                      </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                      <tr>

                                        <td>
                                          <v-checkbox
                                            v-model="props.selected"
                                            color="secondary"
                                            hide-details
                                          />
                                        </td>
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{
                                            props.item.purchase_order.customer_purchase_order_number
                                          }}
                                        </td>
                                        <td class="text-xs-right">
                                          <v-icon small v-if="props.item.purchase_order.proforma" color="secondary"
                                                  class="ma-1"
                                          >
                                            fal fa-check-square
                                          </v-icon>
                                          <v-icon small v-else color="secondary"
                                                  class="ma-1"
                                          >
                                            fal fa-square
                                          </v-icon>
                                        </td>

                                        <td class="text-xs-left">{{
                                            props.item.product.reference
                                          }}
                                        </td>
                                        <td class="text-xs-right">{{ props.item.quantity }}
                                        </td>
                                        <td class="text-xs-right">{{
                                            props.item.unit_sales_price |
                                              toMoney
                                          }} {{ props.item.purchase_order.currency.name }}
                                        </td>
                                        <td class="text-xs-right">{{
                                            props.item.total_sales_price |
                                              toMoney
                                          }} {{ props.item.purchase_order.currency.name }}
                                        </td>

                                      </tr>
                                    </template>
                                  </v-data-table>

                                </v-flex>

                                <!--                                        <v-flex xs12 pa-3>
                                                                            <v-subheader>Outgoing Contact</v-subheader>
                                                                            <v-divider></v-divider>
                                                                        </v-flex>-->

                                <!--                                        <v-flex xs12 md6 pl-4 pr-4>
                                                                            <FakeItem v-show="getInitialLoading">
                                                                            </FakeItem>
                                                                            <v-autocomplete v-show="!getInitialLoading"
                                                                                            clearable
                                                                                            v-model="selectedItem.accounts_id"
                                                                                            :items="allAccounts"
                                                                                            label="Account"
                                                                                            item-value="id"
                                                                                            :filter="customContactFilter"
                                                                            >
                                                                                <template slot="item" slot-scope="data">
                                                                                    <v-list-tile-content>
                                                                                        <v-list-tile-title>
                                                                                            {{ data.item.title ? data.item.title : '' }}
                                                                                            {{
                                                                                            data.item.firstname }} {{
                                                                                            data.item.lastname }}
                                                                                        </v-list-tile-title>
                                                                                    </v-list-tile-content>
                                                                                </template>

                                                                                <template slot="selection" slot-scope="data">
                                                                                    {{ data.item.firstname }} {{ data.item.lastname }}
                                                                                </template>

                                                                                <template slot="no-data">
                                                                                    <v-layout wrap>
                                                                                        <v-flex xs12 pl-4 pr-4>
                                                                                            <v-btn @click.native="" block
                                                                                                   small flat color="secondary">Create
                                                                                                New Account
                                                                                                <v-icon>add</v-icon>
                                                                                            </v-btn>
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                </template>
                                                                            </v-autocomplete>
                                                                        </v-flex>-->
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card flat>
                                <v-flex xs12 pr-3 pl-3>
                                  <v-combobox
                                    clearable
                                    :items="getProducts"
                                    label="Item-Number"
                                    v-model="searchProductsWithPriceVModel"
                                    item-text="reference"
                                    :filter="lesserReferenceFilter"
                                    :loading="loading"
                                    :search-input.sync="searchProductWithPriceInputSync"
                                  ></v-combobox>
                                </v-flex>
                              </v-card>

                              <template>
                                <v-card>
                                  <v-card-title>
                                    Choose Price Calculation
                                  </v-card-title>
                                  <v-data-table
                                    :rows-per-page-items="rowsPageItems"
                                    :loading="loading"
                                    :total-items="totalSearchedPriceProducts"
                                    :headers="headersFreeInvoice"
                                    :items="getSearchedProductsWithPrices">

                                    <template v-slot:items="props">

                                      <tr>
                                        <td>
                                          <v-icon
                                            @click="addPositionForFreeSelectedInvoice(props)"
                                            class="icon-padding" v-html="'fa fa-plus-circle'"></v-icon>
                                        </td>
                                        <td>{{props.item.product.reference}}</td>
                                        <td class="text-xs-right">{{props.item.unit_sales_price}}</td>
                                      </tr>

                                    </template>
                                  </v-data-table>

                                </v-card>
                              </template>

                              <template>
                                <v-card>
                                  <v-card-title>
                                    Selected Products for INVOICE
                                  </v-card-title>
                                  <v-data-table
                                    :headers="headersFreeSelectedInvoice"
                                    :total-items="99"
                                    :items="selectedProductsWithPricesForInvoice">
                                    <template v-slot:items="props">

                                      <tr>
                                        <td>
                                          <v-icon
                                            @click="removePositionFromFreeSelectedInvoice(props)"
                                            class="icon-padding" v-html="'fa fa-minus-circle'"></v-icon>
                                        </td>
                                        <td>{{props.item.product.reference}}</td>
                                        <td>
                                          <v-text-field
                                            label="Quantity"
                                            type="number"
                                            min="1"
                                            v-model="props.item.quantity"
                                          ></v-text-field>
                                        </td>
                                        <td>
                                          <v-autocomplete
                                            clearable
                                            :items="getVats"
                                            v-model="props.item.vats_id"
                                            label="VAT/Tax"
                                            item-value="id"
                                            item-text="name"
                                          ></v-autocomplete>
                                        </td>
                                        <td class="text-xs-right">{{props.item.unit_sales_price}}</td>
                                      </tr>

                                    </template>
                                  </v-data-table>
                                </v-card>
                              </template>

                            </v-tab-item>
                          </v-tabs>
                        </v-card>
                      </v-flex>
                    </template>

                  </v-card-title>
                  <v-card-actions>
                    <v-layout mt-2 pb-3 pr-3>
                      <v-spacer></v-spacer>
                      <v-btn :loading="savingInvoice" dark color="secondary"
                             @click.native="saveAndGoToNextTab(1)">
                        Save
                        <v-icon class="white--text" right>save</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
              <v-layout mt-5 row justify-end>

              </v-layout>

            </v-flex>

          </v-container>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <invoicePositions></invoicePositions>
      </v-tab-item>
      <v-tab-item>
        <pickings></pickings>
      </v-tab-item>
      <v-tab-item>
        <sendInvoiceMessage></sendInvoiceMessage>
      </v-tab-item>
    </v-tabs-items>
  </v-card>

</template>

<script>
import {
  Settings,
  Customer,
  CustomerBranchOffice,
  CustomerBranchOfficeContact,
  PurchaseOrderPosition,
  ContactPersonSettings,
  VatSettings,
  Invoice,
  InvoicePosition,
  Picking,
  SupplierOfferPositions, ProductSettings
} from '../../store/namespace-helper'

import {comboAutoCompleteFiltersMixin} from '../../mixins/comboAutoCompleteFiltersMixin'

import invoicePositions from '../Invoices/InvoicePositions/InvoicePositions.vue'
import pickings from '../Invoices/Pickings/Pickings.vue'
import sendInvoiceMessage from '../Invoices/SendInvoice/SendInvoiceMessage.vue'
import DatetimePicker from '../Shared/DatetimePicker.vue'
import UploadDocumentPicker from '../Shared/UploadDocumentPicker.vue'
import DocumentTokenChip from '../Shared/DocumentTokenChip.vue'
import FakeItem from '../Shared/FakeItem.vue'
import FakeTable from '../Shared/FakeTable.vue'

import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'
import {numberFormatFilters} from '../../mixins/numberFormatFilters'

import _ from 'lodash'

export default {
  components: {
    invoicePositions,
    pickings,
    sendInvoiceMessage,
    DatetimePicker,
    UploadDocumentPicker,
    DocumentTokenChip,
    FakeItem,
    FakeTable
  },
  name: 'add-invoice',
  mixins: [dateFunctionFilters, initialLoadingMixin, numberFormatFilters, comboAutoCompleteFiltersMixin],
  props: {
    procurementId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      headers: [
        {text: 'Order Position-ID', value: 'id'},
        {text: 'Customer Order Number', value: 'customer_purchase_order_number'},
        {text: 'Proforma', value: 'proforma', sortable: false, align: 'right'},
        {text: 'Reference', value: 'reference'},
        {text: 'Quantity', value: 'quantity', align: 'right'},
        {text: 'Unit Price', value: 'unit_price', align: 'right'},
        {text: 'Total Sales Price', value: 'total_sales_price', align: 'right'}
      ],
      headersFreeInvoice: [
        {text: 'Select', value: ''},
        {text: 'Reference', value: 'reference'},
        {text: 'Unit Sales Price', value: 'unit_sales_price', align: 'right'}
      ],
      headersFreeSelectedInvoice: [
        {text: 'Select', value: ''},
        {text: 'Reference', value: 'reference'},
        {text: 'Quantity', value: 'quantity'},
        {text: 'Vats', value: 'vats'},
        {text: 'Unit Sales Price', value: 'unit_sales_price', align: 'right'}
      ],
      countries: this.$store.getters.countries,
      selectedPurchasePositions: [],
      selectedPurchasePositionsIDs: [],
      selectedOfferIDs: [],

      selectedInvoiceTabFreeVModel: null,
      searchProductsWithPriceVModel: [],
      searchProductWithPriceInputSync: '',
      searchedProductsWithPrices: [],
      selectedProductsWithPricesForInvoice: [],

      pagination: {'sortBy': 'id', 'descending': true},
      search: '',
      total: 0,
      totalSearchedPriceProducts: 0,
      rowsPageItems: [{'text': 'All', 'value': -1}],
      customContactFilter (item, queryText, itemText) {
        const isMatch = (test, query) => {
          return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
        }
        const query = queryText || ''
        const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
        const rc = isMatch(item.firstname, query) ||
          isMatch(item.lastname, query) ||
          isMatch(item.email, query) ||
          isMatch(displayText, query)
        console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
        return rc
      },
      isVisible: false,
      supplierContact: {},
      supplierUpdated: 0,
      onDismissed: false,
      sheet: false,
      searchCustomer: '',
      searchCustomerBranchOffice: '',
      searchCustomerBranchOfficeContact: '',
      valid_until: '',
      statuses: [],
      invoiceTypes: [],
      allAccounts: [],
      touchless: true,
      uploadedDocument: null,
      uploadedProformaDocument: null,
      activeTabIndex: 0,
      getReadyForInvoicePositionsLoading: false,
      readyForInvoicePositions: [],
      savingInvoice: false
    }
  },
  mounted () {
    this.loadCurrencies()
    this.loadTermsOfDeliveries()
    this.loadTermsOfPayments()
    this.loadStatuses()
    this.loadInvoiceTypes()
    this.loadAllAccounts()
    this.loadCustomerBranchOffices()
    this.loadCustomerBranchOfficesContacts()
    this.initialLoadingTimeout(850)
  },
  methods: {
    addPositionForFreeSelectedInvoice (item) {
      item.item.quantity = 1
      item.item.vats_id = 2
      this.selectedProductsWithPricesForInvoice.push(item.item)
    },
    removePositionFromFreeSelectedInvoice (item) {
      const findIndex = this.selectedProductsWithPricesForInvoice.findIndex(obj => { return obj.products_id === item.item.products_id })
      this.selectedProductsWithPricesForInvoice.splice(findIndex, 1)
    },
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.loadCurrencies()
          this.loadTermsOfDeliveries()
          this.loadTermsOfPayments()
          this.loadStatuses()
          this.loadInvoiceTypes()
          this.loadAllAccounts()
          this.initialLoadingTimeout(850)
          this.loadVats()
        } else {
          this.supplierUpdated = 0
          this.resetInitialLoadingState()
        }
      }
    },
    closeDialog () {
      this.$store.dispatch(Invoice.actions.setSelectedInvoice, null)
      this.$store.dispatch(Picking.actions.clearPickings)
      this.$store.dispatch(InvoicePosition.actions.clearInvoicePositions)
      this.$store.dispatch(Invoice.actions.openCloseDialog)
      this.readyForInvoicePositions = []
      this.selectedPurchasePositions = []
      this.selectedPurchasePositionsIDs = []
      this.activeTabIndex = 0
    },
    loadCustomers () {
      const query = {
        search: this.searchCustomer ? this.searchCustomer : ''
      }
      this.$store.dispatch(Customer.actions.loadCustomers, query)
    },
    throttledLoadItems: _.debounce(function () {
      this.loadCustomers()
    }, 450),
    loadCustomerBranchOffices () {
      this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedItem.customers_id)
    },
    throttledLoadReadyForInvoicePositions: _.debounce(function () {
      this.loadReadyForInvoicePositions()
    }, 450),
    loadReadyForInvoicePositions () {
      if (this.selectedItem.customers_id !== 0 && this.selectedItem.customers_branch_offices_id !== 0) {
        const {sortBy, descending, page, rowsPerPage} = this.pagination
        const query = {
          sortBy: sortBy || 'id',
          descending: descending ? 'desc' : 'asc',
          page: page || 1,
          limit: rowsPerPage !== -1 ? rowsPerPage : 0,
          search: this.search ? this.search : '',
          customers_id: this.selectedItem.customers_id,
          customers_branch_offices_id: this.selectedItem.customers_branch_offices_id,
          invoices_id: this.selectedItem.id

        }
        this.$store.dispatch(PurchaseOrderPosition.actions.getReadyForInvoicePositions, query).then(response => {
          this.readyForInvoicePositions = response
        }).catch(err => {
          console.log(JSON.stringify(err))
        })
      }
    },
    loadProductsWithPriceListings (referenceId) {
      const query = {
        reference_id: referenceId
      }
      this.$store.dispatch(SupplierOfferPositions.actions.getProductsWithPrices, query).then(response => {
        this.searchedProductsWithPrices = response.data.data
        console.log(this.searchedProductsWithPrices)
      }).catch(err => {
        console.log(JSON.stringify(err))
      })
    },
    loadCustomerBranchOfficesContacts () {
      this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, this.selectedItem.customers_branch_offices_id)
    },
    loadCurrencies () {
      this.$store.dispatch(Settings.actions.loadAllCurrencies)
    },
    loadTermsOfPayments () {
      this.$store.dispatch(Settings.actions.loadTermsOfPayments)
    },
    loadTermsOfDeliveries () {
      this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
    },
    loadStatuses () {
      this.$store.dispatch(Invoice.actions.loadStatuses).then(response => {
        this.statuses = response.data.data
      })
    },
    loadInvoiceTypes () {
      this.$store.dispatch(Invoice.actions.loadInvoiceTypes).then(response => {
        this.invoiceTypes = response.data.data
      })
    },
    loadAllAccounts () {
      this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
        this.allAccounts = response.data.data
      })
    },
    loadAllSuppliers: function () {
      this.$store.dispatch(Settings.actions.loadAllSuppliers)
    },
    loadSupplierContacts (val) {
      this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, val)
    },
    saveAndGoToNextTab (index) {
      this.savingInvoice = true
      const invoice = {
        id: this.selectedItem.id,
        invoices_types_id: this.selectedItem.invoices_types_id,
        invoices_status_id: this.selectedItem.invoices_status_id,
        terms_of_payments_id: this.selectedItem.terms_of_payments_id,
        terms_of_deliveries_id: this.selectedItem.terms_of_deliveries_id,
        currencies_id: this.selectedItem.currencies_id,
        customers_id: this.selectedItem.customers_id,
        customers_branch_offices_id: this.selectedItem.customers_branch_offices_id,
        customers_branch_offices_contacts_id: this.selectedItem.customers_branch_offices_contacts_id,
        due_date: this.selectedItem.due_date,
        invoice_date: this.selectedItem.invoice_date,
        selected_purchase_order_positions: this.selectedPurchasePositionsIDs,
        selected_products_for_free_invoices: this.selectedProductsWithPricesForInvoice,
        invoice_mode: this.selectedInvoiceTabFreeVModel,
        term_remark: this.selectedItem.term_remark
      }

      if (this.selectedInvoiceTabFreeVModel === 1) {
        this.$store.dispatch(Invoice.actions.createFreeInvoice, invoice).then(response => {
          this.savingInvoice = false
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.savingInvoice = false
        })
      } else {
        this.$store.dispatch(Invoice.actions.saveInvoice, invoice).then(response => {
          this.activeTabIndex = index
          this.savingInvoice = false
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.savingInvoice = false
          this.selectedPurchasePositionsIDs = []
          this.selectedPurchasePositions = []
        })
      }
    },
    onDismissedError () {
      this.$store.dispatch(Settings.actions.clearNetworkError)
    },
    openBottomSheet (payload) {
      if (payload) {
        this.$store.dispatch('openCloseBottomSheet')
      }
    },
    loadVats () {
      this.$store.dispatch(VatSettings.actions.loadAllVats)
    },
    loadProducts () {
      const searchObject = {
        search: this.searchProductWithPriceInputSync
      }
      this.$store.dispatch(ProductSettings.actions.loadAllProducts, searchObject)
    },
    throttledLoadProducts: _.debounce(function () {
      this.loadProducts()
    }, 450)

  },
  computed: {
    selectedItem () {
      console.log('selected invoice: ' + JSON.stringify(this.$store.getters[Invoice.getters.getSelectedInvoice]))
      return this.$store.getters[Invoice.getters.getSelectedInvoice]
    },
    getCustomers () {
      return this.$store.getters[Customer.getters.customers]
    },
    getCustomerBranchOffices () {
      return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
    },
    getCustomerBranchOfficesContacts () {
      return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
    },
    getCurrencies () {
      return this.$store.getters[Settings.getters.getAllCurrencies]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    getVats () {
      return this.$store.getters[VatSettings.getters.getAllVats]
    },
    tabsDisabled () {
      return this.$store.getters[Invoice.getters.getSelectedInvoice].id === 0
    },
    pickingTabDisabled () {
      return this.$store.getters[Invoice.getters.getSelectedInvoice].invoices_status_id < 2
    },
    sendInvoiceDisabled () {
      let messageId = this.$store.getters[Invoice.getters.getSelectedInvoice].messages_id
      return messageId === null || messageId === 0
    },
    getAllSuppliers () {
      return this.$store.getters[Settings.getters.getAllSuppliers]
    },
    getSupplierContacts () {
      return this.$store.getters[ContactPersonSettings.getters.getContactPersonsForSupplierId]
    },
    termsOfPayment () {
      return this.$store.getters[Settings.getters.getTermsOfPayments]
    },
    termsOfDelivery () {
      return this.$store.getters[Settings.getters.getTermsOfDeliveries]
    },
    cardTitle () {
      if (this.selectedItem.id === 0) {
        return 'Add new'
      } else {
        return 'Edit'
      }
    },
    getReadyForInvoicePositions () {
      if (this.readyForInvoicePositions && this.readyForInvoicePositions.data) {
        if (this.readyForInvoicePositions.data.data.length > 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.total = this.readyForInvoicePositions.data.data.length
          return this.readyForInvoicePositions.data.data
        }
      }

      this.total = 0
      return []
    },
    getSearchedProductsWithPrices () {
      if (this.searchedProductsWithPrices && this.searchedProductsWithPrices.length != 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.totalSearchedPriceProducts = this.searchedProductsWithPrices.length
        return this.searchedProductsWithPrices
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.totalSearchedPriceProducts = 0
      return []
    },
    getProducts () {
      return this.$store.getters[ProductSettings.getters.getAllProducts]
    }

  },
  watch: {
    pagination: {
      handler () {
        this.throttledLoadReadyForInvoicePositions()
      },
      deep: true
    },
    selectedPurchasePositions: {
      handler (val) {
        this.selectedPurchasePositionsIDs = val.map(a => a.id)
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadReadyForInvoicePositions()
      },
      deep: true
    },
    searchCustomer: {
      handler (val) {
        console.log('searchCustomer data changed: ' + JSON.stringify(val))
        this.throttledLoadItems()
      },
      deep: true

    },
    searchProductWithPriceInputSync: {
      handler (val) {
        if (val && val.length !== 0) {
          this.throttledLoadProducts()
        } else {
          this.$store.dispatch(ProductSettings.actions.resetState)
        }
      },
      deep: true
    },
    searchProductsWithPriceVModel: {
      handler (val) {
        if (val) {
          if (typeof val !== 'string') {
            this.loadProductsWithPriceListings(val.id)
          }
        }
      },
      deep: true
    },
    'selectedItem.customers_id': {
      handler (val) {
        console.log('selectedCustomer data changed: ' + JSON.stringify(val))
        this.loadCustomerBranchOffices()
      },
      deep: false

    },
    'selectedItem.customers_branch_offices_id': {
      handler (val) {
        console.log('selectedCustomerBranchOffice data changed: ' + JSON.stringify(val))
        this.loadCustomerBranchOfficesContacts()
        this.loadReadyForInvoicePositions()
      },
      deep: false

    }
  }

}
</script>

<style scoped>

#menu-button {
  margin-top: 4px;
  width: 55px;
  height: 55px;
}

.fromTop {
  padding-top: 120px;
}

.fixSides::before {
  position: absolute;
  content: "";
  background-color: var(--secondary-color);
  height: 100%;
  width: 110vw;
  top: 0px;
  left: -24px;
}

.statusSelecter {
  width: 80px;
}

.header-switch {
  position: absolute;
  right: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddInvoice.vue